import { FormulasOptions } from "@shared/enums/formulas-options";

// Translation keys ("optionsList.*") for each formula option code, used with the translate pipe
export const FORMULAS_OPTIONS_LABELS: Record<FormulasOptions, string> = {
  [FormulasOptions.OBJVAL]: "",
  [FormulasOptions.VELO]: "optionsList.bikeOption",
  [FormulasOptions.RCS]: "optionsList.schoolOption",
  [FormulasOptions.PJ]: "optionsList.PJOption",
  [FormulasOptions.OPIS]: "optionsList.OPISOption",
  [FormulasOptions.ANO]: "optionsList.NomadProtect",
  [FormulasOptions.PJSOL]: "optionsList.PJOption",
  [FormulasOptions.VAN]: "optionsList.VANOption",
  [FormulasOptions.DOMX]: "optionsList.DOMXOption",
  [FormulasOptions.ROV]: "optionsList.ROVOption",
  [FormulasOptions.RPM]: "optionsList.RPMOption",
  [FormulasOptions.BDG]: "optionsList.BDGOption",
  [FormulasOptions.VLX]: "optionsList.VLXOption",
  [FormulasOptions.OPT_AEXT]: "optionsList.OPT_AEXTOption",
};
